import React, { use } from "react";
import { useState, useEffect, useRef } from "react";
import { TextInput, Dropdown, AccordionV2, AccordionItemV2, Icon, Font, Modal, Checkbox, Button } from "pepsico-ds";
import { useUserProfile } from "../../../common/user_profile_context";
import updateProfileService from "./update_profile.service";
import { toast, ToastContainer } from 'react-toastify';
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { useLoading } from "../../../loader";
import { ActionTypes } from "../../../Redux/Constants/ActionTypes";
import { useDispatch } from "react-redux";

const AssociateAndJobInfoEdit = ({ onPersonalInfoValidate, onShowErrorPage, setUserDetailResp, setShowPreferredLanguageError, showPreferredLanguageError, isEditable, setIsEditable, state, formValues, setFormValues, formChanged, setFormChanged, fieldsChangedRef, showInfoLoader, hideInfoLoader, isInfoLoading, setIsInfoLoading, securityOptions, setSecurityOptions, userDetails, countriesOptions, pronounsOptions, PGCSAccessOptions, preferredLanguageOptions, disableSave, setDisableSave, firstNameError, setFirstNameError, middleNameError, setMiddleNameError, lastNameError, setLastNameError, displayedFirstNameError, setDisplayedFirstNameError, displayedLastNameError, setDisplayedLastNameError, resetField, updateRespFormValuesAfterSuccess }) => {
    const { t, i18n } = useTranslation();
    const isRtl = i18n.language?.split("_")?.[0] === "ar";
    const dispatch = useDispatch();
    const { userProfile, loading } = useUserProfile();
    const [isDisplayNameChanged, setIsDisplayNameChanged] = useState(false);
    const [requestNumber, setRequestNumber] = useState("");
    const navigate = useNavigate();
    const onClickCancel = (shouldResetField=false) => {
        setIsDisplayNameChanged(false);
        setIsEditable(false);
        if(shouldResetField)resetField();
        setFormChanged(false);
    };


    const labels = {
        gpid: "GPID",
        firstName: "First name",
        pronouns: "Pronoun",
        middleName: "Middle Name",
        lastName: "Last name",
        displayedFirstName: "Displayed first name",
        country: "Country",
        mobile: "Mobile",
        phone: "Phone",
        displayedLastName: "Displayed last name",
        preferredName: "Preferred name",
        email: "E-mail",
        alternateEmail: "Alternate email",
        associateType: "Associate type",
        reportingManager: "Reporting Manager",
        organization: "Organization",
        jobTitle: "Job Title",
        jobFunction: "Job Function",
        company: "Company",
        division: "Division",
        subdivision: "Subdivision",
        officePhone: "Office phone",
        extension: "Extension",
        department: "Department",
        category: "Category",
        project: "Project",
        location: "Location",
        registered: "Registered",
        delegatedSecurity: "Associate’s Security Assistant",
        preferredLanguage: "Preferred Language",
        associateSecurity: "Associates who has selected you as  Security assistant",
        expirationDate: "Expiration Date",
        pgcsAccess: "Is PGCS Access Required?"
    };

    const [showModal, setShowModal] = useState(false);
    const [copyButtonText, setCopyButtonText] = useState("Copy number");
    const [showChangeConfirmModal, setShowChangeConfirmModal] = useState(false);
    const [isChecked, setCheckbox] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const handleInputChange = (name, value) => {
        if((name === 'mobile' || name === 'phone' || name === 'officePhone') && value.length > 10) {
            return;
        }
        setFormValues((prev) => ({
            ...prev,
            [name]: value,
        }));
        if (name === 'firstName' || name === 'lastName' || name === 'displayedFirstName') {
            setIsDisplayNameChanged(true);
        }
        setFormChanged(true);
        if(fieldsChangedRef.current?.indexOf(name) === -1){
            fieldsChangedRef.current = [...fieldsChangedRef.current, name]
        }
    };

    const handleDropdownChange = (name, selectedValue) => {
        setFormValues((prev) => ({
            ...prev,
            [name]: selectedValue,
        }));
        if(fieldsChangedRef.current?.indexOf(name) === -1){
            fieldsChangedRef.current = [...fieldsChangedRef.current, name]
        }
        setFormChanged(true);
    };

    const isFieldDisabled = (fieldName) => {
        let disabledFields = [];
        if(state?.userProfileBy === 'Others') {
            if(userProfile?.associateType?.toLowerCase()?.includes("employee")){
                if (formValues?.associateType?.toLowerCase()?.includes("employee") && formValues?.associateType) {
                    disabledFields = ["gpId", "firstName", "middleName", "pronouns", "country", "jobFunction", "lastName", "displayedFirstName", "security", "displayedLastName", "preferredName", "email", "alternateEmail", "mobile", "phone", "associateType", "reportingManager", "jobTitle", "organization", "company", "division", "subdivision", "officePhone", "extension", "department", "category", "project", "location", "registered", "delegatedSecurity", "preferredLanguage", "delegatedManager", "changeDelegatedManager","expirationDate"];
                }
                else if (formValues?.associateType?.toLowerCase()?.includes("contractor") && formValues?.associateType) {
                    disabledFields = ["gpId", "officePhone", "email", "preferredName", "pronouns", "jobFunction", "displayedFirstName", "displayedLastName", "mobile", "alternateEmail", "associateType", "location", "organization", "reportingManager", "division", "subdivision", "department", "location", "registered", "preferredLanguage"];
                }
                else if (formValues?.associateType?.toLowerCase()?.includes("thirdparty") && formValues?.associateType) {
                    disabledFields = ["gpId", "pronouns", "jobFunction", "displayedFirstName", "displayedLastName", "location", "preferredLanguage", "email", "alternateEmail", "mobile", "associateType", "reportingManager", "company", "division", "subdivision", "organization", "department", "category", "project", "registered", "delegatedManager", "changeDelegatedManager","expirationDate"];
                }
                return disabledFields.includes(fieldName);
            }
            else if( userProfile?.associateType?.toLowerCase()?.includes("contractor")) {
                if (formValues?.associateType?.toLowerCase()?.includes("employee") && formValues?.associateType) {
                    disabledFields = ["gpId", "firstName", "middleName", "pronouns", "country", "jobFunction", "lastName", "displayedFirstName", "displayedLastName", "security", "preferredName", "email", "alternateEmail", "mobile", "phone", "associateType", "reportingManager", "jobTitle", "organization", "company", "division", "subdivision", "officePhone", "extension", "department", "category", "project", "location", "registered", "delegatedSecurity", "preferredLanguage", "delegatedManager", "changeDelegatedManager","expirationDate"];
                }
                else if (formValues?.associateType?.toLowerCase()?.includes("contractor") && formValues?.associateType) {
                    disabledFields = ["gpId", "firstName", "lastName", "middleName", "country", "email", "preferredName", "pronouns", "officePhone", "security", "jobFunction", "displayedFirstName", "displayedLastName", "mobile", "alternateEmail", "associateType", "location", "organization", "reportingManager", "division", "subdivision", "department", "location", "registered", "preferredLanguage"];
                }
                else if (formValues?.associateType?.toLowerCase()?.includes("thirdparty") && formValues?.associateType) {
                    disabledFields = ["gpId", "firstName", "pronouns", "jobFunction", "middleName", "lastName", "displayedFirstName", "displayedLastName", "security", "country", "location", "preferredLanguage", "email", "alternateEmail", "mobile", "phone", "associateType", "reportingManager", "company", "division", "subdivision", "organization", "extension", "department", "category", "project", "registered", "delegatedManager", "changeDelegatedManager","expirationDate"];
                }
                return disabledFields.includes(fieldName);
            }
            else if( userProfile?.associateType?.toLowerCase()?.includes("thirdparty")) {
                if (formValues?.associateType?.toLowerCase()?.includes("employee") && formValues?.associateType) {
                    disabledFields = ["gpId", "firstName", "pronouns", "jobFunction", "lastName", "displayedFirstName", "displayedLastName", "preferredName", "email", "alternateEmail", "mobile", "phone", "associateType", "reportingManager", "jobTitle", "company", "division", "subdivision", "officePhone", "extension", "department", "location", "registered", "delegatedSecurity"];
                }
                else if (formValues?.associateType?.toLowerCase()?.includes("contractor") && formValues?.associateType) {
                    disabledFields = ["gpId", "email", "firstName", "lastName", "reportingManager", "preferredLanguage", "security", "country", "phone", "middleName", "preferredName", "pronouns", "jobFunction", "displayedFirstName", "displayedLastName", "mobile", "alternateEmail", "associateType", "location", "organization", "division", "subdivision", "officePhone", "extension", "department", "location", "registered"];
                }
                else if (formValues?.associateType?.toLowerCase()?.includes("thirdparty") && formValues?.associateType) {
                    disabledFields = ["gpId", "firstName", "jobFunction", "middleName", "email", "alternateEmail", "mobile", "associateType", "reportingManager", "company", "division", "subdivision", "organization", "extension", "department", "category", "project", "registered", "delegatedManager", "changeDelegatedManager","expirationDate"];
                }
                return disabledFields.includes(fieldName);
            }
        } 
        else{
            if (userProfile?.associateType?.toLowerCase()?.includes("employee") && userProfile?.associateType) {
                disabledFields = ["gpId", "firstName", "pronouns", "middleName", "jobFunction", "lastName", "displayedFirstName", "displayedLastName", "preferredName", "email", "alternateEmail", "mobile", "phone", "associateType", "reportingManager", "jobTitle", "company", "division", "subdivision", "officePhone", "extension", "department", "location", "registered", "delegatedSecurity"];
            }
            else if (userProfile?.associateType?.toLowerCase()?.includes("contractor") && userProfile?.associateType) {
                disabledFields = ["gpId", "email", "alternateEmail", "jobFunction", "associateType", "location", "organization", "division", "subdivision", "department", "location", "registered", "officePhone"];
            }
            else if (userProfile?.associateType?.toLowerCase()?.includes("thirdparty") && userProfile?.associateType) {
                disabledFields = ["gpId", "firstName", "lastName", "middleName", "jobFunction", "officePhone", "email", "alternateEmail", "mobile", "associateType", "reportingManager", "company", "division", "subdivision", "organization", "location", "department", "category", "project", "registered", "delegatedManager", "changeDelegatedManager", "expirationDate"];
            }
            return disabledFields.includes(fieldName);
        }
    };

    const isFieldMapped = (fieldName) => {
        let fields = [];
        if (userProfile?.associateType?.toLowerCase()?.includes("employee") && userProfile?.associateType && !state?.userProfileBy) {
            fields = ["gpId", "firstName", "pronouns", "pgcsAccess", "middleName", "lastName", "displayedFirstName", "displayedLastName", "preferredName", "email", "alternateEmail", "mobile", "associateType", "reportingManager", "jobTitle", "jobFunction", "company", "division", "subdivision", "location", "department", "extension", "security", "registered", "delegatedSecurity"];
        }
        else if (formValues?.associateType?.toLowerCase()?.includes("employee") && formValues?.associateType && state?.userProfileBy === 'Others'){
            fields = ["gpId", "firstName", "pronouns", "pgcsAccess", "middleName", "lastName", "displayedFirstName", "displayedLastName", "preferredName", "email", "alternateEmail", "mobile", "associateType", "reportingManager", "jobTitle", "jobFunction", "company", "division", "subdivision", "location", "department", "extension", "security", "registered", "delegatedSecurity", ...((userProfile?.associateType?.toLowerCase()?.includes("employee") || userProfile?.associateType?.toLowerCase()?.includes("contractor")) ? ["pgtDelegatedManager"] : [])];
        }
        else if (userProfile?.associateType?.toLowerCase()?.includes("contractor") && userProfile?.associateType && !state?.userProfileBy) {
            fields = ["gpId", "firstName", "pronouns", "pgcsAccess", "middleName", "lastName", "displayedFirstName", "displayedLastName", "email", "alternateEmail", "country", "mobile", "associateType", "reportingManager", "jobFunction", "division", "subdivision", "division", "subdivision", "extension", "registered", "security"];
        }
        else if(formValues?.associateType?.toLowerCase()?.includes("contractor") && formValues?.associateType && state?.userProfileBy === 'Others') {
            fields = ["gpId", "firstName", "pronouns", "pgcsAccess", "middleName", "lastName", "displayedFirstName", "displayedLastName", "email", "alternateEmail", "country", "mobile", "associateType", "reportingManager", "jobFunction", "division", "subdivision", "division", "subdivision", "extension", "registered", "pgtDelegatedManager",  "security"];
        }
        else if (((userProfile?.associateType?.toLowerCase()?.includes("thirdparty") && userProfile?.associateType && !state?.userProfileBy))) {
            fields = ["gpId", "firstName", "pronouns", "pgcsAccess", "middleName", "lastName", "displayedFirstName", "displayedLastName", "email", "alternateEmail", "mobile", "country", "associateType", "reportingManager", "company", "division", "subdivision", "organization", "location", "department", "category", "project", "extension", "registered", "expirationDate"];
        }
        else if((formValues?.associateType?.toLowerCase()?.includes("thirdparty") && formValues?.associateType && state?.userProfileBy === 'Others')){
            fields = ["gpId", "firstName", "pronouns", "pgcsAccess", "middleName", "lastName", "displayedFirstName", "displayedLastName", "email", "alternateEmail", "mobile", "country", "associateType", "reportingManager", "company", "division", "subdivision", "organization", "location", "department", "category", "project", "extension", "delegatedManager", "changeDelegatedManager", "pgtDelegatedManager", "registered", "expirationDate"];
        }
        return fields.includes(fieldName);
    };

    const renderAssociateInfo = () => {
        return (
            <div className="row">
                {isFieldMapped("gpId") && (
                    <div className={isMobile ? "col-6 col-md-4 col-lg-3 mb-3" : "col-12 col-md-4 col-lg-3 mb-3"}>
                        {isEditable ? (
                            <TextInput label={t("updateProfile.gpId")} type="text" value={formValues.gpId} disabled={isFieldDisabled("gpId")} />
                        ) : (
                            <InfoRow label={t("updateProfile.gpId")} value={formValues.gpId || (isInfoLoading ? "" : t("auditRequest.not_applicable"))} />
                        )}
                    </div>
                )}
                {isFieldMapped("firstName") && (
                    <div className={isMobile ? "col-6 col-md-4 col-lg-3 mb-3" : "col-12 col-md-4 col-lg-3 mb-3"}>
                        {isEditable ? (
                            <TextInput label={t("updateProfile.firstName")} type="text" value={formValues.firstName} disabled={isFieldDisabled("firstName")} required={!isFieldDisabled("firstName")} 
                                error={firstNameError}
                                onChange={(e) => {
                                    if(/[^A-Za-z]/.test(e.target.value)) {
                                        setFirstNameError(t("updateProfile.alphabetError"));
                                        setDisableSave(true);
                                    }
                                    else if(firstNameError) {
                                        setFirstNameError("");
                                        setDisableSave(false);
                                    }
                                    handleInputChange("firstName", e.target.value);
                                }} 
                            />
                        ) : (
                            <InfoRow label={t("updateProfile.firstName")} value={formValues.firstName || (isInfoLoading ? "" : t("auditRequest.not_applicable"))} />
                        )}
                    </div>
                )}
                {isFieldMapped("middleName") && (
                    <div className={isMobile ? "col-6 col-md-4 col-lg-3 mb-3" : "col-12 col-md-4 col-lg-3 mb-3"}>
                        {isEditable ? (
                            <TextInput label={t("updateProfile.middleName")} type="text" value={formValues.middleName} disabled={isFieldDisabled("middleName")}  
                            error={middleNameError}
                            onChange={(e) => {
                                if(/[^A-Za-z]/.test(e.target.value)) {
                                    setMiddleNameError(t("updateProfile.alphabetError"));
                                    setDisableSave(true);
                                }
                                    else if(middleNameError) {
                                        setMiddleNameError("");
                                        setDisableSave(false);
                                    }
                                handleInputChange("middleName", e.target.value);
                            }} />
                        ) : (
                            <InfoRow label={t("updateProfile.middleName")} value={formValues.middleName || (isInfoLoading ? "" : t("auditRequest.not_applicable"))} />
                        )}
                    </div>
                )}
                {isFieldMapped("lastName") && (
                    <div className={isMobile ? "col-6 col-md-4 col-lg-3 mb-3" : "col-12 col-md-4 col-lg-3 mb-3"}>
                        {isEditable ? (
                            <TextInput label={t("updateProfile.lastName")} type="text" value={formValues.lastName} disabled={isFieldDisabled("lastName")} required={!isFieldDisabled("lastName")} 
                            error={lastNameError}
                            onChange={(e) => {
                                if(/[^A-Za-z]/.test(e.target.value)) {
                                    setLastNameError(t("updateProfile.alphabetError"));
                                    setDisableSave(true);
                                }
                                    else if(lastNameError) {
                                        setLastNameError("");
                                        setDisableSave(false)
                                    }
                                handleInputChange("lastName", e.target.value)
                            }} />
                        ) : (
                            <InfoRow label={t("updateProfile.lastName")} value={formValues.lastName || (isInfoLoading ? "" : t("auditRequest.not_applicable"))} />
                        )}
                    </div>
                )}

                {isFieldMapped("displayedFirstName") && (
                    <div className={isMobile ? "col-6 col-md-4 col-lg-3 mb-3" : "col-12 col-md-4 col-lg-3 mb-3"}>
                        {isEditable ? (
                            <TextInput
                                label={t("updateProfile.displayedFirstName")}
                                name="displayedFirstName"
                                type="text"
                                required={!isFieldDisabled("displayedFirstName")}
                                disabled={isFieldDisabled("displayedFirstName")}
                                value={formValues.displayedFirstName}
                                error={displayedFirstNameError}
                                onChange={(e) => {
                                    if(/[^A-Za-z]/.test(e.target.value)) {
                                        setDisplayedFirstNameError(t("updateProfile.alphabetError"));
                                        setDisableSave(true);
                                    }
                                    else if(displayedFirstNameError) {
                                        setDisplayedFirstNameError("");
                                        setDisableSave(false);
                                    }
                                    handleInputChange("displayedFirstName", e.target.value);
                                }}
                            />
                        ) : (
                            <InfoRow label={t("updateProfile.displayedFirstName")} value={formValues.displayedFirstName || (isInfoLoading ? "" : t("auditRequest.not_applicable"))} />
                        )}
                    </div>
                )}
                {isFieldMapped("displayedLastName") && (
                    <div className={isMobile ? "col-6 col-md-4 col-lg-3 mb-3" : "col-12 col-md-4 col-lg-3 mb-3"}>
                        {isEditable ? (
                            <TextInput
                                label={t("updateProfile.displayedLastName")}
                                name="displayedLastName"
                                type="text"
                                disabled={isFieldDisabled("displayedLastName")}
                                required={!isFieldDisabled("displayedLastName")}
                                value={formValues.displayedLastName}
                                error={displayedLastNameError}
                                onChange={(e) => {
                                    if(/[^A-Za-z]/.test(e.target.value)) {
                                        setDisplayedLastNameError(t("updateProfile.alphabetError"));
                                        setDisableSave(true)
                                    }
                                    else if(displayedLastNameError) {
                                        setDisplayedLastNameError("");
                                        setDisableSave(false)
                                    }
                                    handleInputChange("displayedLastName", e.target.value);
                                }}
                            />
                        ) : (
                            <InfoRow label={t("updateProfile.displayedLastName")} value={formValues.displayedLastName || (isInfoLoading ? "" : t("auditRequest.not_applicable"))} />
                        )}
                    </div>
                )}
                {isFieldMapped("pronouns") && (
                    <div className={isMobile ? "col-6 col-md-4 col-lg-3 mb-3" : "col-12 col-md-4 col-lg-3 mb-3"}>
                        {isEditable ? (
                            <Dropdown
                                childList={pronounsOptions?.sort?.((a, b) => { return a?.displayText?.localeCompare?.(b.displayText); })}
                                label={t("updateProfile.pronouns")}
                                placeholder="Select Pronouns"
                                isClearable
                                disabled={isFieldDisabled("pronouns")}
                                selection="single"
                                size="medium"
                                setSelectedValue={(selected) => handleDropdownChange("pronouns", selected)}
                                selectedValue={formValues?.pronouns || null}
                                onKeyDown={(e) => e.preventDefault()}
                                showLabelIcon={false}
                            />
                        ) : (
                            <InfoRow label={t("updateProfile.pronouns")} value={formValues.pronouns?.[0]?.displayText || (isInfoLoading ? "" : t("auditRequest.not_applicable"))} />
                        )}
                    </div>
                )}
                {isFieldMapped("preferredName") && (
                    <div className={isMobile ? "col-6 col-md-4 col-lg-3 mb-3" : "col-12 col-md-4 col-lg-3 mb-3"}>
                        {isEditable ? (
                            <TextInput
                                label={t("updateProfile.preferredName")}
                                name="preferredName"
                                type="text"
                                disabled={isFieldDisabled("preferredName")}
                                value={formValues.preferredName}
                                onChange={(e) => handleInputChange("preferredName", e.target.value)}
                            />
                        ) : (
                            <InfoRow label={t("updateProfile.preferredName")} value={formValues.preferredName || (isInfoLoading ? "" : t("auditRequest.not_applicable"))} />
                        )}
                    </div>
                )}
                {isFieldMapped("email") && (
                    <div className={isMobile ? "col-6 col-md-4 col-lg-3 mb-3" : "col-12 col-md-4 col-lg-3 mb-3"}>
                        {isEditable ? (
                            <TextInput label={t("updateProfile.email")} type="text" value={formValues.email} disabled={isFieldDisabled("email")} />
                        ) : (
                            <InfoRow label={t("updateProfile.email")} value={formValues.email || (isInfoLoading ? "" : t("auditRequest.not_applicable"))} />
                        )}
                    </div>
                )}
                {isFieldMapped("alternateEmail") && (
                    <div className={isMobile ? "col-6 col-md-4 col-lg-3 mb-3" : "col-12 col-md-4 col-lg-3 mb-3"}>
                        {isEditable ? (
                            <TextInput
                                label={t("updateProfile.alternateEmail")}
                                name="alternateEmail"
                                type="text"
                                value={formValues.alternateEmail}
                                onChange={(e) => handleInputChange("alternateEmail", e.target.value)}
                                disabled={isFieldDisabled("alternateEmail")}
                            />
                        ) : (
                            <div>
                                <InfoRow label={t("updateProfile.alternateEmail")} value={formValues.alternateEmail || (isInfoLoading ? "" : t("auditRequest.not_applicable"))} />
                                {/* <Button
                                className=""
                                size="small"
                                text="Validate"
                                variant="tertiary"
                                onClick={() => { }}
                                iconTrailing="arrow_forward"
                            /> */}
                                {/* {localStorage.getItem('isEmailVerified') !== 'true' ?
                                    <div className="my-account-btn mt-3" onClick={onPersonalInfoValidate}>Validate
                                        <Icon
                                            alt="alt value"
                                            icon="arrow_forward"
                                            size="medium"
                                            style={{ marginLeft: '8px' }}
                                        />
                                    </div> :
                                    <div className="my-account-verified-btn mt-3">
                                        <Icon
                                            alt="alt value"
                                            icon="check_circle"
                                            size="medium"
                                            style={{ marginLeft: '8px', color: 'green' }}
                                        /> Verified
                                    </div>
                                } */}
                            </div>
                        )}
                    </div>
                )}
                {isFieldMapped("country") && (
                    <div className={isMobile ? "col-6 col-md-4 col-lg-3 mb-3" : "col-12 col-md-4 col-lg-3 mb-3"}>
                        {isEditable ? (
                            <Dropdown
                                childList={countriesOptions?.sort?.((a, b) => { return a?.displayText?.localeCompare?.(b.displayText); })}
                                label={t("updateProfile.country")}
                                placeholder="Select Country"
                                isClearable
                                disabled={isFieldDisabled("country")}
                                selection="single"
                                size="medium"
                                setSelectedValue={(selected) => handleDropdownChange("country", selected)}
                                selectedValue={formValues?.country || null}
                                onKeyDown={(e) => e.preventDefault()}
                                showLabelIcon={false}
                            />
                        ) : (
                            <div>
                                <InfoRow label={t("updateProfile.country")} value={formValues.country?.[0]?.displayText || (isInfoLoading ? "" : t("auditRequest.not_applicable"))} />
                                {/* <div className="my-account-btn" onClick={onPersonalInfoValidate}>Validate
                                    <Icon
                                        alt="alt value"
                                        icon="arrow_forward"
                                        size="medium"
                                        style={{ marginLeft: '8px' }}
                                    />
                                </div> */}
                            </div>
                        )}
                    </div>
                )}
                {isFieldMapped("extension") && (
                    <div className={isMobile ? "col-6 col-md-4 col-lg-3 mb-3" : "col-12 col-md-4 col-lg-3 mb-3"}>
                        {isEditable ? (
                            <TextInput
                                label={t("updateProfile.ext")}
                                name="extension"
                                type="text"
                                disabled={isFieldDisabled("extension")}
                                value={formValues.extension}
                                // onChange={(e) => handleInputChange("extension", e.target.value)}
                                onKeyDown={(e) => {
                                    if (!/[0-9+]/.test(e.key) && e.key !== "Backspace" && e.key !== "Delete" && e.key !== "ArrowLeft" && e.key !== "ArrowRight" && e.key !== "Tab") {
                                        e.preventDefault();
                                    }
                                }}
                                onChange={(e) => {
                                    let val = e.target.value;
                                    val = val.replace(/[^0-9+]/g, "");
                                    handleInputChange("extension", val);
                                }}
                            />
                        ) : (
                            <InfoRow label={t("updateProfile.ext")} value={formValues.extension || (isInfoLoading ? "" : t("auditRequest.not_applicable"))} />
                        )}
                    </div>
                )}
                {isFieldMapped("mobile") && (
                    <div className={isMobile ? "col-6 col-md-4 col-lg-3 mb-3" : "col-12 col-md-4 col-lg-3 mb-3"}>
                        {isEditable ? (
                            <TextInput
                                label={t("updateProfile.phone")}
                                name="mobile"
                                type="tel"
                                inputMode="numeric"
                                maxLength={10}
                                disabled={isFieldDisabled("phone")}
                                value={formValues.phone}
                                onKeyDown={(e) => {
                                    if (!/[0-9]/.test(e.key) && e.key !== "Backspace" && e.key !== "Delete" && e.key !== "ArrowLeft" && e.key !== "ArrowRight" && e.key !== "Tab") {
                                        e.preventDefault();
                                    }
                                }}
                                onChange={(e) => {
                                    let val = e.target.value;
                                    val = val.replace(/\D/g, "");
                                    if (val.length > 10) {
                                        val = val.slice(0, 10);
                                    }
                                    handleInputChange("phone", val);
                                }}
                            />
                        ) : (
                            <div>
                                <InfoRow label={t("updateProfile.phone")} value={formValues.phone || (isInfoLoading ? "" : t("auditRequest.not_applicable"))} />
                                {/* {localStorage.getItem('isPhoneVerified') !== 'true' ?
                                    <div className="my-account-btn mt-3" onClick={onPersonalInfoValidate}>Validate
                                        <Icon
                                            alt="alt value"
                                            icon="arrow_forward"
                                            size="medium"
                                            style={{ marginLeft: '8px' }}
                                        />
                                    </div> :
                                    <div className="my-account-verified-btn mt-3">
                                        <Icon
                                            alt="alt value"
                                            icon="check_circle"
                                            size="medium"
                                            style={{ marginLeft: '8px' }}
                                        />Verified
                                    </div>} */}
                            </div>
                        )}
                    </div>
                )}
            </div>
        );
    }

    const renderJonInfo = () => {
        return (
            <div className="row">
                {isFieldMapped("associateType") && (
                    <div className={isMobile ? "col-6 col-md-4 col-lg-3 mb-3" : "col-12 col-md-4 col-lg-3 mb-3"}>
                        {isEditable ? (
                            <TextInput label={t("updateProfile.associateType")} type="text" value={formValues.associateType} disabled={isFieldDisabled("associateType")} />
                        ) : (
                            <InfoRow label={t("updateProfile.associateType")} value={formValues.associateType || (isInfoLoading ? "" : t("auditRequest.not_applicable"))} />
                        )}
                    </div>
                )}

                {isFieldMapped("reportingManager") && (
                    <div className={isMobile ? "col-6 col-md-4 col-lg-3 mb-3" : "col-12 col-md-4 col-lg-3 mb-3"}>
                        {isEditable ? (
                            <>
                                {!formValues?.reportingManager ? (
                                    <div className="text-input $font-body-regular">
                                        <span className="label-element">
                                            <span className="label-text $font-xsmall-regular">
                                                <label>{t("updateProfile.reportingManager")}</label>
                                            </span>
                                        </span>
                                        <Button variant="secondary" className="w-100 justify-content-center" style={{fontWeight: "700"}} text="Browse" size="medium" onClick={() => searchReportingManager('reportingManager')} />
                                    </div>
                                ) : (
                                    <TextInput
                                        label={t("updateProfile.reportingManager")}
                                        name="reportingManager"
                                        type="text"
                                        disabled={isFieldDisabled("reportingManager")}
                                        value={formValues.reportingManager}
                                        onUpdate={(e) => handleInputChange("reportingManager", e)}
                                    />
                                )
                                }
                            </>
                        ) : (
                            <InfoRow label={t("updateProfile.reportingManager")} value={formValues.reportingManager || (isInfoLoading ? "" : t("auditRequest.not_applicable"))} />
                        )}
                    </div>
                )}
                {isFieldMapped("jobTitle") && (
                    <div className={isMobile ? "col-6 col-md-4 col-lg-3 mb-3" : "col-12 col-md-4 col-lg-3 mb-3"}>
                        {isEditable ? (
                            <TextInput label={t("updateProfile.jobTitle")} type="text" value={formValues.jobTitle} disabled={isFieldDisabled("jobTitle")} />
                        ) : (
                            <InfoRow label={t("updateProfile.jobTitle")} value={formValues.jobTitle || (isInfoLoading ? "" : t("auditRequest.not_applicable"))} />
                        )}
                    </div>
                )}
                {isFieldMapped("jobFunction") && (
                    <div className={isMobile ? "col-6 col-md-4 col-lg-3 mb-3" : "col-12 col-md-4 col-lg-3 mb-3"}>
                        {isEditable ? (
                            <TextInput
                                label={t("updateProfile.jobFunction")}
                                name="jobFunction"
                                type="text"
                                disabled={isFieldDisabled("jobFunction")}
                                value={formValues.jobFunction}
                                onChange={(e) => handleInputChange("jobFunction", e.target.value)}
                            />
                        ) : (
                            <InfoRow label={t("updateProfile.jobFunction")} value={formValues.jobFunction || (isInfoLoading ? "" : t("auditRequest.not_applicable"))} />
                        )}
                    </div>
                )}
                {isFieldMapped("company") && (
                    <div className={isMobile ? "col-6 col-md-4 col-lg-3 mb-3" : "col-12 col-md-4 col-lg-3 mb-3"}>
                        {isEditable ? (
                            <TextInput label={t("updateProfile.company")} type="text" value={formValues.company} disabled={isFieldDisabled("company")} />
                        ) : (
                            <InfoRow label={t("updateProfile.company")} value={formValues.company || (isInfoLoading ? "" : t("auditRequest.not_applicable"))} />
                        )}
                    </div>
                )}
                {isFieldMapped("division") && (
                    <div className={isMobile ? "col-6 col-md-4 col-lg-3 mb-3" : "col-12 col-md-4 col-lg-3 mb-3"}>
                        {isEditable ? (
                            <TextInput label={t("updateProfile.division")} type="text" value={formValues.division} disabled={isFieldDisabled("division")} />
                        ) : (
                            <InfoRow label={t("updateProfile.division")} value={formValues.division || (isInfoLoading ? "" : t("auditRequest.not_applicable"))} />
                        )}
                    </div>
                )}
                {isFieldMapped("subdivision") && (
                    <div className={isMobile ? "col-6 col-md-4 col-lg-3 mb-3" : "col-12 col-md-4 col-lg-3 mb-3"}>
                        {isEditable ? (
                            <TextInput label={t("updateProfile.subdivision")} type="text" value={formValues.subdivision} disabled={isFieldDisabled("subdivision")} />
                        ) : (
                            <InfoRow label={t("updateProfile.subdivision")} value={formValues.subdivision || (isInfoLoading ? "" : t("auditRequest.not_applicable"))} />
                        )}
                    </div>
                )}
                {isFieldMapped("organization") && (
                    <div className={isMobile ? "col-6 col-md-4 col-lg-3 mb-3" : "col-12 col-md-4 col-lg-3 mb-3"}>
                        {isEditable ? (
                            <TextInput
                                label={t("updateProfile.organization")}
                                name="organization"
                                type="text"
                                disabled={isFieldDisabled("organization")}
                                value={formValues.organization}
                                onChange={(e) => handleInputChange("organization", e.target.value)}
                            />
                        ) : (
                            <InfoRow label={t("updateProfile.organization")} value={formValues.organization|| (isInfoLoading ? "" : t("auditRequest.not_applicable"))} />
                        )}
                    </div>
                )}
                {isFieldMapped("location") && (
                    <div className={isMobile ? "col-6 col-md-4 col-lg-3 mb-3" : "col-12 col-md-4 col-lg-3 mb-3"}>
                        {isEditable ? (
                            <TextInput label={t("updateProfile.location")} type="text" value={formValues.location} disabled={isFieldDisabled("location")} />
                        ) : (
                            <InfoRow label={t("updateProfile.location")} value={formValues.location || (isInfoLoading ? "" : t("auditRequest.not_applicable"))} />
                        )}
                    </div>
                )}
                {isFieldMapped("officePhone") && (
                    <div className={isMobile ? "col-6 col-md-4 col-lg-3 mb-3" : "col-12 col-md-4 col-lg-3 mb-3"}>
                        {isEditable ? (
                            <TextInput
                                label={t("updateProfile.officePhone")}
                                name="officePhone"
                                type="text"
                                disabled={isFieldDisabled("officePhone")}
                                value={formValues.officePhone}
                                onKeyDown={(e)=>{
                                    if (!/[0-9]/.test(e.key) && e.key !== "Backspace" && e.key !== "Delete" && e.key !== "ArrowLeft" && e.key !== "ArrowRight" && e.key !== "Tab") {
                                        e.preventDefault();
                                    }
                                }}
                                onChange={(e) => {
                                    let val = e.target.value;
                                    val = val.replace(/\D/g, "");
                                    if (val.length > 10) {
                                        val = val.slice(0, 10);
                                    }
                                    handleInputChange("officePhone", val);
                                }}
                            />
                        ) : (
                            <InfoRow label={t("updateProfile.officePhone")} value={formValues.officePhone || (isInfoLoading ? "" : t("auditRequest.not_applicable"))} />
                        )}
                    </div>
                )}
                {isFieldMapped("department") && (
                    <div className={isMobile ? "col-6 col-md-4 col-lg-3 mb-3" : "col-12 col-md-4 col-lg-3 mb-3"}>
                        {isEditable ? (
                            <TextInput
                                label={t("updateProfile.department")}
                                name="department"
                                type="text"
                                disabled={isFieldDisabled("department")}
                                value={formValues.department}
                                onChange={(e) => handleInputChange("department", e.target.value)}
                            />
                        ) : (
                            <InfoRow label={t("updateProfile.department")} value={formValues.department || (isInfoLoading ? "" : t("auditRequest.not_applicable"))} />
                        )}
                    </div>
                )}
                {isFieldMapped("category") && (
                    <div className={isMobile ? "col-6 col-md-4 col-lg-3 mb-3" : "col-12 col-md-4 col-lg-3 mb-3"}>
                        {isEditable ? (
                            <TextInput label={t("updateProfile.category")} type="text" value={formValues.category} disabled={isFieldDisabled("category")} />
                        ) : (
                            <InfoRow label={t("updateProfile.category")} value={formValues.category || (isInfoLoading ? "" : t("auditRequest.not_applicable"))} />
                        )}
                    </div>
                )}
                {isFieldMapped("project") && (
                    <div className={isMobile ? "col-6 col-md-4 col-lg-3 mb-3" : "col-12 col-md-4 col-lg-3 mb-3"}>
                        {isEditable ? (
                            <TextInput label={t("updateProfile.project")} type="text" value={formValues.project} disabled={isFieldDisabled("project")} />
                        ) : (
                            <InfoRow label={t("updateProfile.project")} value={formValues.project || (isInfoLoading ? "" : t("auditRequest.not_applicable"))} />
                        )}
                    </div>
                )}
                {isFieldMapped("delegatedManager") && (
                    <div className={isMobile ? "col-6 col-md-4 col-lg-3 mb-3" : "col-12 col-md-4 col-lg-3 mb-3"}>
                        {isEditable ? (
                            <TextInput
                                label={t("updateProfile.delegatedManager")}
                                name="delegatedManager"
                                type="text"
                                disabled={isFieldDisabled("delegatedManager")}
                                value={formValues.delegatedManager}
                                onChange={(e) => handleInputChange("delegatedManager", e.target.value)}
                            />
                        ) : (
                            <InfoRow label={t("updateProfile.delegatedManager")} value={formValues.delegatedManager || (isInfoLoading ? "" : t("auditRequest.not_applicable"))} />
                        )}
                    </div>
                )}
                {isFieldMapped("changeDelegatedManager") && (
                    <div className={isMobile ? "col-6 col-md-4 col-lg-3 mb-3" : "col-12 col-md-4 col-lg-3 mb-3"}>
                        {isEditable ? (
                            <Dropdown
                                childList={[{ displayText: 'Yes', value: 'Yes' }, { displayText: 'No', value: 'No' }]}
                                label={t("updateProfile.changeDelegatedManager")}
                                placeholder="Select"
                                isClearable
                                disabled={isFieldDisabled("changeDelegatedManager")}
                                selection="single"
                                size="medium"
                                setSelectedValue={(selected) => handleDropdownChange("changeDelegatedManager", selected)}
                                selectedValue={formValues.changeDelegatedManager}
                                onKeyDown={(e) => e.preventDefault()}
                            />
                        ) : (   
                            <InfoRow label={t("updateProfile.changeDelegatedManager")} value={formValues.changeDelegatedManager?.displayText || (isInfoLoading ? "" : t("auditRequest.not_applicable"))} />
                        )}
                    </div>
                )}
                {isFieldMapped("pgtDelegatedManager") && (
                    <div className={isMobile ? "col-6 col-md-4 col-lg-3 mb-3" : "col-12 col-md-4 col-lg-3 mb-3"}>
                        {isEditable ? (
                            <>
                                {!formValues?.pgtDelegatedManager ? (
                                    <div className="text-input $font-body-regular">
                                        <span className="label-element">
                                            <span className="label-text $font-xsmall-regular">
                                                <label>{t("updateProfile.pgtDelegatedManager")}</label>
                                            </span>
                                        </span>
                                        <Button variant="secondary" className="w-100 justify-content-center" style={{fontWeight: "700"}} text="Browse" size="medium" onClick={() => searchReportingManager('pgtDelegatedManager')} />
                                    </div>
                                ) : (
                                    <TextInput
                                        label={t("updateProfile.pgtDelegatedManager")}
                                        name="pgtDelegatedManager"
                                        type="text"
                                        disabled={isFieldDisabled("pgtDelegatedManager")}
                                        value={formValues.pgtDelegatedManager}
                                        onUpdate={(e) => handleInputChange("pgtDelegatedManager", e)}
                                        className="pgt-input-non-editable"
                                    />
                                )
                                }
                            </>
                        ) : (
                            <InfoRow label={t("updateProfile.pgtDelegatedManager")} value={formValues.pgtDelegatedManager || (isInfoLoading ? "" : t("auditRequest.not_applicable"))} />
                        )}
                    </div>
                )}
                {isFieldMapped("phone") && (
                    <div className={isMobile ? "col-6 col-md-4 col-lg-3 mb-3" : "col-12 col-md-4 col-lg-3 mb-3"}>
                        {isEditable ? (
                            <TextInput
                                label={t("auditRequest.phone_label")}
                                name="phone"
                                type="tel"
                                inputMode="numeric"
                                maxLength={10}
                                disabled={isFieldDisabled("phone")}
                                value={formValues.phone}
                                onKeyDown={(e)=>{
                                    if (!/[0-9]/.test(e.key) && e.key !== "Backspace" && e.key !== "Delete" && e.key !== "ArrowLeft" && e.key !== "ArrowRight" && e.key !== "Tab") {
                                        e.preventDefault();
                                    }
                                }}
                                onChange={(e) => {
                                    let val = e.target.value;
                                    val = val.replace(/\D/g, "");
                                    if (val.length > 10) {
                                        val = val.slice(0, 10);
                                    }
                                    handleInputChange("phone", val);
                                }}
                            />
                        ) : (
                            <InfoRow label={t("auditRequest.phone_label")} value={formValues.phone || (isInfoLoading ? "" : t("auditRequest.not_applicable"))} />
                        )}
                    </div>
                )}
                {isFieldMapped("registered") && (
                    <div className={isMobile ? "col-6 col-md-4 col-lg-3 mb-3" : "col-12 col-md-4 col-lg-3 mb-3"}>
                        {isEditable ? (
                            <TextInput label={t("updateProfile.registered")} type="text" value={formValues.registered} disabled={isFieldDisabled("registered")} />
                        ) : (
                            <InfoRow label={t("updateProfile.registered")} value={formValues.registered || (isInfoLoading ? "" : t("auditRequest.not_applicable"))} />
                        )}
                    </div>
                )}
                {isFieldMapped("delegatedSecurity") && (
                    <div className={isMobile ? "col-6 col-md-4 col-lg-3 mb-3" : "col-12 col-md-4 col-lg-3 mb-3"}>
                        {isEditable ? (
                            <TextInput label={t("updateProfile.delegatedSecurity")} type="text" value={formValues.delegatedSecurity} disabled={isFieldDisabled("delegatedSecurity")} />
                        ) : (
                            <InfoRow label={t("updateProfile.delegatedSecurity")} value={formValues.delegatedSecurity || (isInfoLoading ? "" : t("auditRequest.not_applicable"))} />
                        )}
                    </div>
                )}
                {isFieldMapped("security") && (
                    <div className={isMobile ? "col-6 col-md-4 col-lg-3 mb-3" : "col-12 col-md-4 col-lg-3 mb-3"}>
                        {isEditable ? (
                            <Dropdown
                                childList={securityOptions?.sort?.((a, b) => { return a?.displayText?.localeCompare?.(b.displayText); })}
                                label={t("updateProfile.associateSecurity")}
                                disabled={!securityOptions?.length || isFieldDisabled("security")}
                                placeholder="Select"
                                isClearable
                                selection="multiple"
                                size="medium"
                                setSelectedValue={(selected) => handleDropdownChange("security", selected)}
                                selectedValue={formValues.security}
                                onKeyDown={(e) => e.preventDefault()}
                                showLabelIcon={false}
                            />
                            // <TextInput label={t("updateProfile.associateSecurity")} type="text" value={formValues.associateSecurity} disabled={isFieldDisabled("security")} />
                        ) : (
                            <InfoRow label={t("updateProfile.associateSecurity")} value={securityOptions?.map?.((val) => (val.id))?.join?.(',') || (isInfoLoading ? "" : t("auditRequest.not_applicable"))} />
                        )}
                    </div>
                )}
                {isFieldMapped("expirationDate") && (
                    <div className={isMobile ? "col-6 col-md-4 col-lg-3 mb-3" : "col-12 col-md-4 col-lg-3 mb-3"}>
                        {isEditable ? (
                            <TextInput label={t("updateProfile.expirationDate")} type="text" value={formValues.expirationDate} disabled={isFieldDisabled("expirationDate")} />
                        ) : (
                            <InfoRow label={t("updateProfile.expirationDate")} value={formValues.expirationDate || (isInfoLoading ? "" : t("auditRequest.not_applicable"))} />
                        )}
                    </div>
                )}
                {isFieldMapped("pgcsAccess") && (
                    <div className={isMobile ? "col-6 col-md-4 col-lg-3 mb-3" : "col-12 col-md-4 col-lg-3 mb-3"}>
                        {isEditable ? (
                            <Dropdown
                                childList={PGCSAccessOptions?.sort?.((a, b) => { return a?.displayText?.localeCompare?.(b.displayText); })}
                                label={t("updateProfile.PGCSAccess")}
                                placeholder="Select PGCS Access"
                                isClearable
                                disabled={isFieldDisabled("pgcsAccess")}
                                selection="single"
                                size="medium"
                                setSelectedValue={(selected) => handleDropdownChange("pgcsAccess", selected)}
                                selectedValue={formValues?.pgcsAccess || null}
                                onKeyDown={(e) => e.preventDefault()}
                                showLabelIcon={false}
                            />
                        ) : (
                            <InfoRow label={t("updateProfile.PGCSAccess")} value={formValues.pgcsAccess?.[0]?.displayText || (isInfoLoading ? "" : t("auditRequest.not_applicable"))} />
                        )}
                    </div>
                )}
            </div>
        )
    }

    const renderLanguageInfo = () => {
        return (
            <div className="info-grid">
                {isEditable ? (
                    <Dropdown
                        childList={preferredLanguageOptions?.sort?.((a, b) => { return a?.displayText?.localeCompare?.(b.displayText); })}
                        label={t("updateProfile.preferredLanguage")}
                        placeholder="Choose Language"
                        disabled={isFieldDisabled("preferredLanguage")}
                        isClearable
                        selection="single"
                        appendTo="body"
                        style={{minWidth:"140px"}}
                        size="medium"
                        setSelectedValue={(selected) => {
                            if(selected && showPreferredLanguageError) setShowPreferredLanguageError(false)
                            handleDropdownChange("preferredLanguage", selected)
                        }}
                        selectedValue={formValues.preferredLanguage}
                        onKeyDown={(e) => e.preventDefault()}
                        isRequired={!isFieldDisabled("preferredLanguage")}
                        showLabelIcon={false}
                    />
                ) : (
                    <InfoRow label={t("updateProfile.preferredLanguage")} value={formValues.preferredLanguage?.[0]?.displayText || (isInfoLoading ? "" : t("auditRequest.not_applicable"))} />
                )}
            </div>
        );
    }

    const closeModal = () => {
        setShowModal(false);
        setCheckbox(false);
    }
    const onClickCheckbox = (isChecked) => {
        setCheckbox(isChecked);
    }

    const searchReportingManager = (searchType) => {
        dispatch({ type: ActionTypes.USER_DETAIL, payload: {formValues, securityOptions, userDetails, disableSave, firstNameError, middleNameError, lastNameError, displayedFirstNameError, displayedLastNameError, fieldsChangedRef: fieldsChangedRef?.current || []} })
        navigate('/search-reporting-manager', { state: { from: 'update-profile', searchType: searchType, userProfileBy: state?.userProfileBy, associateType: formValues.associateType, gpId: formValues.gpId } });
        //navigate to request-new-access-others page
        // navigate('/manage-accounts/request-new-access-others');
        // setIsInfoLoading(true);
    }

    const handleSaveChange = () => {
        if(!formValues.preferredLanguage?.[0]?.id && !isFieldDisabled("preferredLanguage")){
            setShowPreferredLanguageError(true)
            return
        }

        isDisplayNameChanged ? setShowModal(true) : onClickAccept()
    }

    const onClickAccept = async () => {
        setDisableSave(true);
        showInfoLoader();
        const selectedSecurityIds = formValues?.security?.map((val) => val.id);

        const deSelectedSecurity = securityOptions?.filter((val) => !selectedSecurityIds.includes(val.id))

        const payload = {
            gpid: formValues.gpId,
            // valueChanged: true,
            associateType: formValues.associateType,
            ...(!isFieldDisabled("firstName") && fieldsChangedRef.current?.includes?.("firstName") && {firstName: formValues.firstName}),
            ...(!isFieldDisabled("lastName") && fieldsChangedRef.current?.includes?.("lastName") && {lastName: formValues.lastName}),
            ...(!isFieldDisabled("middleName") && fieldsChangedRef.current?.includes?.("middleName") && {middleName: formValues.middleName}),
            ...(!isFieldDisabled("displayedFirstName") && fieldsChangedRef.current?.includes?.("displayedFirstName") && {displayFirstName: formValues.displayedFirstName, 
                isDisplaynameUpdated: true,
                isDisplayUpdateRequired: true
            }),
            ...(!isFieldDisabled("displayedLastName") && fieldsChangedRef.current?.includes?.("displayedLastName") && {displayLastName: formValues.displayedLastName, 
                isDisplaynameUpdated: true,
                isDisplayUpdateRequired: true
            }),
            ...(!isFieldDisabled("jobFunction") && fieldsChangedRef.current?.includes?.("jobFunction") && {jobFunction: formValues.jobFunction}),
            ...(!isFieldDisabled("security") && fieldsChangedRef.current?.includes?.("security") && {securityAssistance: deSelectedSecurity?.map((val) => val.id)?.join(',')}),
            ...(!isFieldDisabled("reportingManager") && fieldsChangedRef.current?.includes?.("reportingManager") && {reportingManager: formValues.reportingManager}),
            ...(!isFieldDisabled("preferredLanguage") && fieldsChangedRef.current?.includes?.("preferredLanguage") && {preferredLanguage: formValues.preferredLanguage?.[0]?.id || ""}),
            ...(!isFieldDisabled("pronouns") && fieldsChangedRef.current?.includes?.("pronouns") && {pronouns: formValues.pronouns?.[0]?.displayText || ""}),
            ...(!isFieldDisabled("pgcsAccess") && fieldsChangedRef.current?.includes?.("pgcsAccess") && {pgcsAccess: formValues.pgcsAccess?.[0]?.displayText || ""}),
            ...(!isFieldDisabled("country") && fieldsChangedRef.current?.includes?.("country") && {country: formValues.country?.[0]?.displayText}),
            ...(!isFieldDisabled("phone") && fieldsChangedRef.current?.includes?.("phone") && {phone: formValues.phone}),
            ...(!isFieldDisabled("extension") && fieldsChangedRef.current?.includes?.("extension") && {pager: formValues.extension}),
        }

        try {
            let response;
            if(state?.userProfileBy === 'Others'){
                let body;
                // if(userDetails?.associateType?.toLowerCase()?.includes("employee")){
                //     body = {
                //         "gpid": formValues.gpId,
                //         "associateType": "EMPLOYEE",
                //         "parentGpid": userProfile?.gpId,
                //         ...(!isFieldDisabled("pgtDelegatedManager") && {"pgtDelegatedManager": formValues?.pgtDelegatedManager || ""})
                //     }
                // }
                // else if(userDetails?.associateType?.toLowerCase()?.includes("thirdparty")){
                //     body = {
                //         "gpid": formValues.gpId,
                //         "associateType": "THIRDPARTY",
                //         "parentGpid": userProfile?.gpId,
                //         ...(!isFieldDisabled("firstName") && {"firstName": formValues.firstName || ""}),
                //         ...(!isFieldDisabled("lastName") && {"lastName": formValues.lastName || ""}),
                //         ...(!isFieldDisabled("middleName") && {"middleName": formValues.middleName || ""}),
                //         ...(!isFieldDisabled("pgtDelegatedManager") && {"pgtDelegatedManager": formValues?.pgtDelegatedManager || ""}),
                //         ...(!isFieldDisabled("country") && {country: formValues.country?.[0]?.displayText}),
                //         ...(!isFieldDisabled("phone") && {phone: formValues.phone}),
                //         ...(!isFieldDisabled("extension") && {"pager":formValues.extension})
                //     }
                // }
                // else if(userDetails?.associateType?.toLowerCase()?.includes("contractor")){
                    // body = {
                    //     "gpid": formValues.gpId,
                    //     "associateType": "CONTRACTOR",
                    //     "parentGpid": userProfile?.gpId,
                    //     ...(!isFieldDisabled("firstName") && {"firstName": formValues.firstName || ""}),
                    //     ...(!isFieldDisabled("lastName") && {"lastName": formValues.lastName || ""}),
                    //     ...(!isFieldDisabled("middleName") && {"middleName": formValues.middleName || ""}),
                    //     ...(!isFieldDisabled("pgtDelegatedManager") && {"pgtDelegatedManager": formValues?.pgtDelegatedManager || ""}),
                    //     ...(!isFieldDisabled("jobFunction") && {"jobFunction": "IT"}),
                    //     ...(!isFieldDisabled("country") && {country: formValues.country?.[0]?.displayText}),
                    //     ...(!isFieldDisabled("phone") && {phone: formValues.phone}),
                    //     ...(!isFieldDisabled("extension") && {"pager":formValues.extension}),
                    //     ...(!(!securityOptions?.length || isFieldDisabled("security")) && {"securityAssistance": formValues.security.length ? formValues.security?.map((val) => val.id) :  ""})
                    // }
                // }
                body = {
                        "gpid": formValues.gpId,
                        "associateType": userDetails?.associateType?.toLowerCase()?.includes("employee") ? "EMPLOYEE" : userDetails?.associateType?.toLowerCase()?.includes("thirdparty") ? "THIRDPARTY" : userDetails?.associateType?.toLowerCase()?.includes("contractor") ? "CONTRACTOR" : userDetails?.associateType?.toUpperCase?.(),
                        "parentGpid": userProfile?.gpId,
                        ...(!isFieldDisabled("firstName") && fieldsChangedRef.current?.includes?.("firstName") && {"firstName": formValues.firstName || ""}),
                        ...(!isFieldDisabled("lastName") && fieldsChangedRef.current?.includes?.("lastName") && {"lastName": formValues.lastName || ""}),
                        ...(!isFieldDisabled("middleName") && fieldsChangedRef.current?.includes?.("middleName") && {"middleName": formValues.middleName || ""}),
                        ...(!isFieldDisabled("pgtDelegatedManager") && fieldsChangedRef.current?.includes?.("pgtDelegatedManager") && {"pgtDelegatedManager": formValues?.pgtDelegatedManager || ""}),
                        ...(!isFieldDisabled("jobFunction") && fieldsChangedRef.current?.includes?.("jobFunction") && {"jobFunction": formValues.jobFunction || ""}),
                        ...(!isFieldDisabled("country") && fieldsChangedRef.current?.includes?.("country") && {country: formValues.country?.[0]?.displayText || ""}),
                        ...(!isFieldDisabled("phone") && fieldsChangedRef.current?.includes?.("phone") && {phone: formValues.phone || ""}),
                        ...(!isFieldDisabled("extension") && fieldsChangedRef.current?.includes?.("extension") && {"pager": formValues.extension || ""}),
                        ...(!isFieldDisabled("displayedFirstName") && fieldsChangedRef.current?.includes?.("displayedFirstName") && {"displayFirstName": formValues.displayedFirstName || ""}),
                        ...(!isFieldDisabled("displayedLastName") && fieldsChangedRef.current?.includes?.("displayedLastName") && {"displayLastName": formValues.displayedLastName || ""}),
                        ...(!isFieldDisabled("reportingManager") && fieldsChangedRef.current?.includes?.("reportingManager") && {"reportingManager": formValues.reportingManager || ""}),
                        ...(!isFieldDisabled("preferredLanguage") && fieldsChangedRef.current?.includes?.("preferredLanguage") && {"preferredLanguage": formValues.preferredLanguage?.[0]?.id || ""}),
                        ...(!isFieldDisabled("pronouns") && fieldsChangedRef.current?.includes?.("pronouns") && {"pronouns": formValues.pronouns?.[0]?.displayText || ""}),
                        ...(!isFieldDisabled("pgcsAccess") && fieldsChangedRef.current?.includes?.("pgcsAccess") && {"pgcsAccess": formValues.pgcsAccess?.[0]?.displayText || ""}),
                        ...(!(!securityOptions?.length || isFieldDisabled("security")) && fieldsChangedRef.current?.includes?.("security") && {"securityAssistance": formValues.security.length ? formValues.security?.map((val) => val.id) :  ""})
                    }
                response = await updateProfileService.updateProfileDetailsOfOthers(body);
            }
            else{
                response = await updateProfileService.updateProfileDetails(payload);
            }
            if (response?.responseStatus === 'Success' || response?.status === 'Success') {
                setDisableSave(false);
                hideInfoLoader();
                setShowModal(false);
                setShowChangeConfirmModal(true);
                setIsEditable(false);
                setFormChanged(false);
                setCheckbox(false);
                setCopyButtonText("Copy number");
                toast.success("Profile updated successfully", "success");
                setRequestNumber(`${response?.requestNumber}`);
                updateRespFormValuesAfterSuccess();
            }
            else {
                setDisableSave(false);
                hideInfoLoader();
                toast.error("Failed to update profile","error");
                setShowModal(false);
            }
        } catch (error) {
            setShowChangeConfirmModal(false);
            console.error("Error updating profile details:", error);
            toast.error("Failed to update profile");
            hideInfoLoader();
        } finally {

            // setShowModal(false);
            // setShowChangeConfirmModal(true);
            // setIsEditable(false);
            // setFormChanged(false);
            // setCheckbox(false);
            // setCopyButtonText("Copy number");
        }
    }
    const onCloseChangeModal = () => {
        setShowChangeConfirmModal(false);
        onClickCancel();
    }

    const onClickCopynumber = () => {
        navigator.clipboard.writeText(requestNumber)
        setCopyButtonText("Copied");

    }

    const renderChangeRequestConfirm = () => {
        return (
            <Modal
                showModal={showChangeConfirmModal}
                className=""
                onCloseModal={onCloseChangeModal}
                
                notificationsProps={{
                    primaryActionLabel: (
                        <>
                            <Icon
                                alt="alt value"
                                icon={copyButtonText == "Copied" ? "check" : "content_copy"}
                                size="medium"
                                style={{ marginRight: '6px', display: 'unset' }}
                            />

                            {copyButtonText}
                        </>
                    ),
                    primaryActionOnClick: onClickCopynumber,
                    text: requestNumber,
                    title: 'Ticket Number',
                    type: 'info'
                }}
                showAuxiliaryButton={false}
                showLink={false}
                showPrimaryButton
                secondaryButtonProps={{
                    text: 'Back',
                    variant: "tertiary",
                    onClick: () => {
                        onCloseChangeModal()
                    }
                }}
                primaryButtonProps={{
                    text: 'View Requests',
                    variant: "primary",
                    onClick: async () => {
                        closeModal();
                        if(!userProfile?.pepappiamcentralfeatures?.includes('RequestAudit')){
                            window.open("https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?task.tag=ViewMyRequestsAuditSAP")
                        }else{
                            let statePayload = { type: "requestNumber", value: requestNumber };
                            navigate("/audit-requests", { state: statePayload });
                        }
                        // navigate("/myidmPortal", { state: { navigateFrom: "extension_request"} });
                        // window.open("https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?task.tag=PendingApprovals", "_blank");
                    },
                }}
                showSecondaryButton
                showSlot
                showTertiaryButton={false}
                showCloseButton={true}
                style={{}}
                text={`The ticket number assign to this request is: ${requestNumber}. Please save this number to reference the request in the future.`}
                title="Change request confirmation"
                type="fluid"
                viewPort={isMobile ? "mobile" : "desktop"}
            >
            </Modal>
        )
    }

    const renderConfirmModal = () => {
        return (
            <Modal
                showModal={showModal}
                className=""
                onCloseModal={closeModal}
                closeOnOutsideClick = {false}
                // footerProps={{
                //     size: 'medium',
                //     type: 'primary'
                // }}
                notificationsProps={{
                    text: 'While meant to be inclusivity resource, Display Name requests should be kept to a minimum and used on an as needed basis only.',
                    title: '',
                    type: 'warning',
                }}
                showAuxiliaryButton={false}
                showLink={false}
                showPrimaryButton={false}
                showSecondaryButton={false}
                showSlot
                showTertiaryButton={false}
                showCloseButton={true}
                style={{}}
                text="Making this change to Display Name will create a system-wide Display Name change in several down-stream applications (for example email & Zoom). Please ensure correct spelling, and note that Display Names should be used in a professional and responsible manner, including in compliance with Company policy and all applicable laws."
                title="Change Display Name?"
                type="fluid"
                viewPort={isMobile ? "mobile" : "desktop"}
            >
                <Checkbox
                    checked={isChecked}
                    className=""
                    size="large"
                    style={{}}
                    onUpdate={(value) => onClickCheckbox(value)}
                    text="I have read and understand the information listed above"
                />
                <div className="confirm-modal-btn">
                    <Button
                        className=""
                        size="medium"
                        style={{}}
                        text="Cancel"
                        variant="tertiary"
                        onClick={closeModal}
                    />
                    <Button
                        className=""
                        size="medium"
                        style={{}}
                        text="Accept & continue"
                        variant="primary"
                        disabled={!isChecked}
                        onClick={onClickAccept}
                    />

                </div>
            </Modal>
        )
    }

    const renderMobile = () => (
        <div className="main-container">
            <div className="mobile-profile-wrapper">
                <div className="mobile-profile-container">
                    <AccordionV2
                        className=""
                        presentation="border"
                        separator
                        style={{}}
                    >
                        <AccordionItemV2
                            label={t("updateProfile.associateInfo")}
                            icon="person"
                            presentation="box-shadow"
                            key={"associateInfo"}
                        >
                            <Font textColorClass="$color-text-secondary">
                                {renderAssociateInfo()}
                            </Font>
                        </AccordionItemV2>
                        <AccordionItemV2
                            label={t("updateProfile.jobInfo")}
                            icon="domain"
                            key={"jobInfo"}
                        >
                            <Font textColorClass="$color-text-secondary">
                                {renderJonInfo()}
                            </Font>
                        </AccordionItemV2>
                        <AccordionItemV2
                            label={t("updateProfile.language")}
                            icon="translate"
                            key={"language"}
                        >
                            <Font textColorClass="$color-text-secondary">
                                {renderLanguageInfo()}
                            </Font>
                        </AccordionItemV2>
                    </AccordionV2>

                </div>
                {isEditable ?
                    <div className="save-container">
                        <div className="edit-status">
                            <span style={{ fontSize: 14, color: "#616161" }}>
                                {/* {formChanged ? fieldsChanged.length + " changes made" : "0 changes made"} */}
                                {formChanged ? fieldsChangedRef.current?.length + " changes made" : "0 changes made"}
                            </span>
                        </div>

                        <div className="edit-status">
                            <button className="mobile-save-button" style={{ marginBottom: 4 }} onClick={handleSaveChange} 
                                disabled={!formChanged || disableSave || (isFieldMapped("firstName") && !isFieldDisabled("firstName") && !formValues.firstName) || (isFieldMapped("lastName") && !isFieldDisabled("lastName") && !formValues.lastName) || (isFieldMapped("displayedFirstName") && !isFieldDisabled("displayedFirstName") && !formValues.displayedFirstName) || (isFieldMapped("displayedLastName") && !isFieldDisabled("displayedLastName") && !formValues.displayedLastName)}
                            >
                                Save changes
                            </button>
                            <button className="mobile-cancel-button" onClick={()=>onClickCancel(true)}>
                                Cancel
                            </button>
                        </div>
                    </div>
                    : <div className="save-container justify-content-end">
                        <button className="edit-button" onClick={setIsEditable.bind(this, true)}>
                            <Icon
                                alt="alt value"
                                icon="edit"
                                size="medium"
                                style={{ marginRight: '8px' }}
                            />Edit Mode
                        </button>
                    </div>
                }
            </div>
            {showModal && renderConfirmModal()}
            {showChangeConfirmModal && renderChangeRequestConfirm()}
            <ToastContainer
                position="bottom-center"
            />
        </div>
    );

    const renderDesktop = () => (
        <div className="main-container">
            <div className="associate-infor-container">
                <section className="section associate-info">
                    <Icon
                        alt="alt value"
                        icon="person"
                        size="large"
                        style={{ marginBottom: '8px', color: "#3A3A3A", ...(isRtl && {direction: "rtl"}) }}
                    />
                    <h3 style={{ color: "#0E647F" }}>{t("updateProfile.associateInfo")}</h3>
                    {renderAssociateInfo()}
                </section>

                <hr className="profile-divider" />

                <section className="section job-info">
                    <Icon
                        alt="alt value"
                        icon="domain"
                        size="large"
                        style={{ marginBottom: '8px', color: "#3A3A3A", ...(isRtl && {direction: "rtl"})  }}
                    />
                    <h3 style={{ color: "#0E647F" }}>{t("updateProfile.jobInfo")}</h3>
                    {renderJonInfo()}
                </section>

                <hr className="profile-divider" />

                <section className="section language-info">
                    <Icon
                        alt="alt value"
                        icon="translate"
                        size="large"
                        style={{ marginBottom: '8px', color: "#3A3A3A", ...(isRtl && {direction: "rtl"}) }}
                    />
                    <h3 style={{ color: "#0E647F" }}>{t("updateProfile.language")}</h3>
                    {renderLanguageInfo()}
                </section>
                <hr className="profile-divider" />
            </div>
            {isEditable ?
                <div>
                    <div className="d-flex justify-content-between pr-4">
                        <div className="edit-status">
                            <span style={{ fontSize: 14, color: "#616161" }}>
                                {/* {formChanged ? fieldsChanged.length + " change made" : "0 changes made"} */}
                                {formChanged ? fieldsChangedRef.current?.length + " change made" : "0 changes made"}
                            </span>
                        </div>

                        <div className="edit-actions">
                            <button className="cancel-button" onClick={()=>onClickCancel(true)}>
                                <Icon
                                    alt="alt value"
                                    icon="close"
                                    size="large"
                                    style={{ marginRight: '8px' }}
                                />
                                Cancel
                            </button>
                            <button className="save-button" 
                                disabled={!formChanged || disableSave || (isFieldMapped("firstName") && !isFieldDisabled("firstName") && !formValues.firstName) || (isFieldMapped("lastName") && !isFieldDisabled("lastName") && !formValues.lastName) || (isFieldMapped("displayedFirstName") && !isFieldDisabled("displayedFirstName") && !formValues.displayedFirstName) || (isFieldMapped("displayedLastName") && !isFieldDisabled("displayedLastName") && !formValues.displayedLastName)} 
                                onClick={handleSaveChange}
                            >
                                Save changes
                            </button>
                        </div>
                    </div>
                </div>
                : 
                <>
                {
                    userProfile?.pepappiamcentralfeatures?.includes('UpdateProfile') ? <div>
                        <div className="d-flex justify-content-end pr-4">
                            <button className="edit-button" onClick={setIsEditable.bind(this, true)}>
                                <Icon
                                    alt="alt value"
                                    icon="edit"
                                    size="large"
                                    style={{ marginRight: '8px' }}
                                />
                                Edit mode
                            </button>
                        </div>
                    </div> : null
                }
                </>
            }
            {showModal && renderConfirmModal()}
            {showChangeConfirmModal && renderChangeRequestConfirm()}
            <ToastContainer
                position="bottom-center"
            />
        </div>
    );

    return isMobile ? renderMobile() : renderDesktop();
};

const InfoRow = ({ label, value }) => (
    <Font textColorClass="$color-text-secondary">
        <div className="profile-info">
            <span className="profile-label">{label}</span>
            <span className="profile-value">{value}</span>
        </div>
    </Font>
);

export default AssociateAndJobInfoEdit;
